// CST207: const tuple of all i18n namespaces.
// Keep in lockstep with resources.ts and the locales/{de,en}/*.json files.
export const NAMESPACES = [
  "common",
  "errors",
  "marketing",
  "auth",
  "search",
  "results",
  "icp",
  "credits",
  "settings",
  "onboarding",
  "members",
  "admin",
] as const;

export type Namespace = (typeof NAMESPACES)[number];
